<div *ngIf='valueController' class='boolean-customfield' [formGroup]='valueController'>
  <mat-checkbox [formControlName]="'boolValue'">{{label}}</mat-checkbox>
</div>
